export default __webpack_public_path__ + "static/media/19-04-23-banner-farm-mobile.7966196c.jpg";